"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.characterFormTranslator = void 0;
exports.characterFormTranslator = {
    en: {
        name: "Name*",
        role: "Role",
        backstory: "Backstory",
        abilities: "Abilities",
        traits: "Traits",
        mainImage: "Main Image",
        additionalImages: "Additional Images",
        save: "Save",
        nameRequired: "Name is required",
        characterNotFound: "Character not found",
        success: "Success"
    },
    ru: {
        name: "Имя*",
        role: "Роль",
        backstory: "Предыстория",
        abilities: "Способности",
        traits: "Черты",
        mainImage: "Основное изображение",
        additionalImages: "Дополнительные изображения",
        save: "Сохранить",
        nameRequired: "Имя обязательно для заполнения",
        characterNotFound: "Запрашиваемый персонаж не найден",
        success: "Сохранено"
    },
};
